export default "__VITE_ASSET__CJoVBYTT__"